/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

// Commit: Reorganize imports for better readability
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Grid, TextField, FormGroup, Card, CardContent } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { withTranslation } from 'react-i18next';

import { UPLOAD_FILE } from '../../queries';
import { loginArrayFromStorage } from "../../services/auth.service";
import { useThemeData } from '../../context/ThemeDataContext';
import GeneralText from "../../components/Fonts";
import GeneralButton from "../Buttons";

// Commit: Remove unused state variable
function PhotoUploadComponent({ folder_id, type, t, location }) {
    const {site_id} = useThemeData().themeData.site;
    const {photographerType} = useThemeData();
    const {font_family, primary_color_2 } = useThemeData().themeData.site.theme;
    const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
    const [Message, setMessage] = useState({ successMessage: false });
    const [filename, setFilename] = useState('no image');
    const [newFolderId, setNewFolderId] = useState('no image');
    const [newId, setNewId] = useState('no image');
    const login_name = photographerType === 'printservice' ? photographerType : localStorage.getItem('login_name');
    const login_email = localStorage.getItem('login_email');

    const logins = JSON.parse(login_name);

// Access the first element of the array
    const firstLogin = logins[0];

    // Commit: Simplify type assignment
    // const isUploadPath = location.pathname === '/upload-photo';
    // const uploadType = isUploadPath ? location.state.type : type;

    const [singleUpload, { loading: loadingSingleUpload, error: errorSingleUpload }]
        = useMutation(UPLOAD_FILE, {
            onCompleted: (e) => {
                setFilename(e.singleUpload.filename);
                setNewFolderId(e.singleUpload.folder_id);
                setNewId(e.singleUpload.id);
                setMessage({ successMessage: true });

                loginArrayFromStorage(e.singleUpload.login_name, 'login_name');
            }
        }
    );

    const goBackHome = () => {
        if(filename==='no image' ) {
            window.location.href = `/shoppage/photo_id/${localStorage.getItem("photo_id")}`
        }else{
            window.location.href = `/shoppage/photo_id/${newId}/3981`
        }
    }

    if (loadingSingleUpload) return <p>{t('Loading...')}</p>
    if (errorSingleUpload) return <p>{t('Looks like we have a problem...')}</p>

    // Commit: Simplify rendering logic and remove duplicate styling
    return (
        <Grid item lg={12} md={6} style={{ fontFamily: font_family, color: primary_color_2 }}>
        <Card style={{ fontFamily: font_family, color: primary_color_2 }}>
                <CardContent className="contact-text">
                    {Message.successMessage && <Alert severity="success">{t('photoUpload:Photo ready')}</Alert>}
                    <Grid container spacing={1} direction="row" className="justify-content-center">
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Grid container direction="row">
                                <GeneralText style={{ color: primary_color_2 }} variant="h6" gutterBottom>
                                    {t('photoUpload:Upload and order your own photos')}
                                </GeneralText>
                            </Grid>
                            <form className="contact-text" onSubmit={() => { console.log("Submitted") }} encType={'multipart/form-data'}>
                                <p>{t('photoUpload:Products')}</p>
                                <FormGroup>
                                    <TextField
                                      name='document'
                                      type='file'
                                      onChange={({ target: { files } }) => {
                                          const file = files[0];
                                          if (file) {
                                              // Check if the file size is at least 1 MB
                                              if (file.size >= 716800 && file.size <= 1572864) {
                                                  singleUpload({
                                                      variables: {
                                                          file: file,
                                                          login_name: firstLogin,
                                                          login_email: login_email,
                                                          site_id: site_id,
                                                          folder_id: folder_id
                                                      }
                                                  });
                                              } else {
                                                  // Handle the error case where file size is less than 1 MB
                                                  alert('De foto moet minimaal 700KB zijn en maximaal 1.5MB.');
                                              }
                                          }
                                      }}
                                    />
                                </FormGroup>
                                <GeneralButton onClick={goBackHome} className="btn btn-light btn-margin">
                                    {t('photoUpload:Back to the Shop')}
                                </GeneralButton>
                            </form>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            {filename!=='no image' && (
                              <img alt="test" className="max-width-fill" src={`${PHOTO_URL}${site_id}/${newFolderId}/0/0/0/0/${newId}/${filename}`} />
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default React.memo(withTranslation(['message', 'photoUpload'])(PhotoUploadComponent));
